import { CircleDollarSign, RefreshCcw } from 'lucide-react'
import { FormattedNumber } from '../../../FormattedNumber'

export type DrawerCreditsUsageProps = {
  creditsUsage?: number
  loading?: boolean
  error?: Error | null
  onRefetch?: () => void
}

export function DrawerCreditsUsage (props: DrawerCreditsUsageProps) {
  const { creditsUsage, loading, error, onRefetch } = props

  const available = creditsUsage ?? 0

  return (
    <div className="w-full flex items-center justify-between gap-4 text-xs p-2 border-1 rounded-md hover:bg-base-200/50 transition-colors duration-200 ease-in-out">
      <span className='font-bold'>Credits</span>
      {error
        ? (
          <>
            <span className="text-error">Error fetching data usage</span>
            <button
              className="btn btn-sm btn-ghost btn-circle"
              onClick={event => {
                event.preventDefault()
                onRefetch?.()
              }}
            >
              <RefreshCcw size={16} />
            </button>
          </>
          )
        : (
          <>
            {loading
              ? (
                <div className="skeleton w-24 h-6" />
                )
              : (
                <div className="flex justify-between items-center bg-base-200 border min-w-24 p-2 rounded-md font-light">
                  <div className='flex gap-1 items-center w-full justify-between'>
                    <CircleDollarSign size={16} className="text-gray-500" strokeWidth={3} />
                    <FormattedNumber value={available} />
                  </div>
                </div>
                )}
          </>
          )}
    </div>
  )
}
